/** История сцены 3D композиции (undo/redo), короткое хранение в localStorage. */

import {
    MODULE_3D_HISTORY_MAX,
    MODULE_3D_HISTORY_TTL_MS,
    pushHistorySnapshot,
    redoHistory,
    undoHistory,
} from "../module3d/module3dHistory";

export {pushHistorySnapshot, undoHistory, redoHistory, MODULE_3D_HISTORY_MAX};

export const getComposition3DHistoryKey = (compositionId) =>
    `composition-3d-history-v1:${compositionId}`;

const cloneJson = (value) => {
    try {
        return structuredClone(value);
    } catch {
        try {
            return JSON.parse(JSON.stringify(value));
        } catch {
            return null;
        }
    }
};

/** Лёгкий снимок модуля на сцене композиции (без children / тяжёлых данных). */
const slimModuleForHistory = (inst) => {
    if (!inst) return inst;
    const pacedModule = inst.pacedModule ?? inst.row?.pacedModule ?? null;
    return {
        instanceId: inst.instanceId,
        moduleKey: inst.moduleKey,
        moduleApiId: inst.moduleApiId ?? null,
        localPosition: inst.localPosition
            ? {
                x: Number(inst.localPosition.x) || 0,
                y: Number(inst.localPosition.y) || 0,
                z: Number(inst.localPosition.z) || 0,
            }
            : {x: 0, y: 0, z: 0},
        axes: cloneJson(inst.axes) || inst.axes,
        faceFlip: Boolean(inst.faceFlip),
        euler: cloneJson(inst.euler) || inst.euler,
        hidden: Boolean(inst.hidden),
        pacedModuleId: inst.pacedModuleId ?? pacedModule?.id ?? null,
        pacedModule: pacedModule
            ? {
                id: pacedModule.id,
                hide: pacedModule.hide,
                anchorPoint: pacedModule.anchorPoint,
                axesX: pacedModule.axesX,
                axesY: pacedModule.axesY,
                axesZ: pacedModule.axesZ,
                faceFlip: pacedModule.faceFlip,
            }
            : null,
        row: inst.row
            ? {
                id: inst.row.id,
                moduleId: inst.row.moduleId,
                moduleCompositionId: inst.row.moduleCompositionId,
                pacedModule,
            }
            : null,
    };
};

export const createCompositionHistorySnapshot = ({
    placedModules,
    selectedInstanceId = null,
    pacedModuleIdByKey = {},
    clearedPacedKeys = [],
}) => ({
    at: Date.now(),
    selectedInstanceId: selectedInstanceId ?? null,
    pacedModuleIdByKey: {...(pacedModuleIdByKey || {})},
    clearedPacedKeys: Array.from(clearedPacedKeys || []),
    placedModules: (Array.isArray(placedModules) ? placedModules : []).map(slimModuleForHistory),
});

export const loadComposition3DHistory = (compositionId) => {
    if (compositionId == null || compositionId === "") {
        return {past: [], future: []};
    }
    try {
        const raw = localStorage.getItem(getComposition3DHistoryKey(compositionId));
        if (!raw) return {past: [], future: []};
        const parsed = JSON.parse(raw);
        const savedAt = Number(parsed?.savedAt) || 0;
        if (!savedAt || Date.now() - savedAt > MODULE_3D_HISTORY_TTL_MS) {
            localStorage.removeItem(getComposition3DHistoryKey(compositionId));
            return {past: [], future: []};
        }
        return {
            past: Array.isArray(parsed.past) ? parsed.past : [],
            future: Array.isArray(parsed.future) ? parsed.future : [],
        };
    } catch {
        return {past: [], future: []};
    }
};

export const saveComposition3DHistory = (compositionId, {past, future}) => {
    if (compositionId == null || compositionId === "") return;
    try {
        const payload = {
            savedAt: Date.now(),
            past: (past || []).slice(-MODULE_3D_HISTORY_MAX),
            future: (future || []).slice(0, MODULE_3D_HISTORY_MAX),
        };
        localStorage.setItem(getComposition3DHistoryKey(compositionId), JSON.stringify(payload));
    } catch {
        // quota / private mode
    }
};
